<div class="itf-database-container">
  <!-- Search Mode Selector -->
  <div class="search-mode-selector">
    <button 
      [class.active]="searchMode === 'simple'" 
      (click)="searchMode = 'simple'; resetSearch()">
      <i class="fas fa-search"></i> Búsqueda Simple
    </button>
    <button 
      [class.active]="searchMode === 'complex'" 
      (click)="searchMode = 'complex'; resetSearch()">
      <i class="fas fa-filter"></i> Búsqueda Compleja
    </button>
  </div>

  <!-- SIMPLE SEARCH MODE -->
  <div *ngIf="searchMode === 'simple'" class="simple-search">
    <div class="global-search">
      <header>
        <div class="title-group">
          <h1>ITF Database - Búsqueda Simple</h1>
        </div>
      </header>
      
      <div class="search-controls">
        <!-- Search Type Selector -->
        <div class="search-type-selector">
          <label class="radio-option">
            <input 
              type="radio" 
              name="searchType" 
              value="libreta"
              [(ngModel)]="searchType"
              (change)="onSearchTypeChange()">
            <span>
              <i class="fas fa-id-card"></i>
              Nro. Libreta
            </span>
          </label>
          
          <label class="radio-option">
            <input 
              type="radio" 
              name="searchType" 
              value="documento"
              [(ngModel)]="searchType"
              (change)="onSearchTypeChange()">
            <span>
              <i class="fas fa-address-card"></i>
              Nro. Documento
            </span>
          </label>
        </div>

        <!-- Search Input (changes based on searchType) -->
        <div class="search-input-row">
          <!-- Nro. Libreta Input -->
          <ng-container *ngIf="searchType === 'libreta'">
            <label>Número de libreta:</label>
            <input 
              #searchInput 
              [(ngModel)]="nroLibreta" 
              type="number" 
              placeholder="Ej: 123" 
              (keyup.enter)="buscar()" />
          </ng-container>

          <!-- Nro. Documento Input -->
          <ng-container *ngIf="searchType === 'documento'">
            <label>Número de documento:</label>
            <input 
              #searchInput 
              [(ngModel)]="nroDocumento" 
              type="text" 
              placeholder="Ej: 12345678" 
              (keyup.enter)="buscar()" />
          </ng-container>

          <button class="search" (click)="buscar()">
            <i class="fas fa-search"></i>
            Buscar
          </button>
        </div>
        
        <div *ngIf="error && !showRegisterPrompt" class="error-message">
          <i class="fas fa-exclamation-triangle"></i>
          <p>{{ error }}</p>
        </div>

        <!-- Graduation Warning Alert -->
        <div *ngIf="graduationWarning && itfRecord" class="warning-message">
          <i class="fas fa-exclamation-triangle"></i>
          <p>{{ graduationWarning }}</p>
        </div>
      </div>
    </div>

    <!-- Register Prompt -->
    <div *ngIf="showRegisterPrompt" class="register-prompt">
      <!-- Estudiante Encontrado -->
      <div *ngIf="estudianteData" class="estudiante-encontrado">
        <h3>
          <i class="fas fa-user-check"></i>
          Estudiante encontrado
        </h3>
        
        <div class="estudiante-info-card">
          <div class="info-row">
            <i class="fas fa-id-card"></i>
            <span class="label">Nro. Libreta:</span>
            <span class="value">{{ estudianteData.nroLibreta }}</span>
          </div>
          
          <div class="info-row">
            <i class="fas fa-user"></i>
            <span class="label">Nombre:</span>
            <span class="value">{{ estudianteData.apellido }}, {{ estudianteData.nombre }}</span>
          </div>
          
          <div class="info-row" *ngIf="estudianteData.documento">
            <i class="fas fa-address-card"></i>
            <span class="label">Documento:</span>
            <span class="value">{{ estudianteData.documento }}</span>
          </div>
          
          <div class="info-row" *ngIf="estudianteData.email">
            <i class="fas fa-envelope"></i>
            <span class="label">Email:</span>
            <span class="value">{{ estudianteData.email }}</span>
          </div>
          
          <div class="info-row" *ngIf="estudianteData.fcNacimiento">
            <i class="fas fa-birthday-cake"></i>
            <span class="label">Fecha Nacimiento:</span>
            <span class="value">{{ formatDate(estudianteData.fcNacimiento) }}</span>
          </div>
          
          <div class="info-row" *ngIf="estudianteData.nacionalidad">
            <i class="fas fa-flag"></i>
            <span class="label">Nacionalidad:</span>
            <span class="value">{{ estudianteData.nacionalidad }}</span>
          </div>
        </div>
        
        <div class="centered-button">
          <button (click)="registerNewRecord()" class="new-button">
            <i class="fas fa-user-plus"></i>
            <span>Registrar en ITF Database</span>
          </button>
        </div>
      </div>

      <!-- No Estudiante -->
      <div *ngIf="!estudianteData" class="no-estudiante">
        <h3>
          <i class="fas fa-user-times"></i>
          Estudiante no encontrado
        </h3>
        <p>El nro_libreta <strong>{{ nroLibreta }}</strong> no existe en el sistema.</p>
        <p>¿Desea crear un registro ITF sin vincular a estudiante?</p>
        
        <div class="centered-buttons">
          <button (click)="registerWithoutNroLibreta()" class="new-button">
            <i class="fas fa-user-plus"></i>
            <span>Crear sin vínculo</span>
          </button>
          <button (click)="resetSearch()" class="cancel-btn">
            <i class="fas fa-times"></i>
            <span>Cancelar</span>
          </button>
        </div>
      </div>
    </div>

    <!-- ITF Record Detail -->
    <app-itf-database-detail 
      *ngIf="itfRecord" 
      [itfRecord]="itfRecord" 
      [isNew]="isNew"
      (cancelEdit)="handleCancelEdit()">
    </app-itf-database-detail>
  </div>

  <!-- ============================================================================
       COMPLEX SEARCH MODE - NEW
       ============================================================================ -->
  <div *ngIf="searchMode === 'complex'" class="complex-search">
    <div class="global-search full-width">
      <header>
        <div class="title-group">
          <h1>ITF Database - Búsqueda Avanzada</h1>
        </div>
      </header>

      <!-- Filters Container -->
      <div class="filters-container">
        <form [formGroup]="searchForm" (ngSubmit)="filterItfRecords()">
          <div class="filters-section">
            <h2>Filtros de búsqueda</h2>
            
            <div class="filters-grid">
              
              <!-- ROW 1: Apellido | Nombre | Sexo | Nacionalidad -->
              <div class="filter-group">
                <label>Apellido</label>
                <input type="text" formControlName="apellido" placeholder="Buscar...">
              </div>

              <div class="filter-group">
                <label>Nombre</label>
                <input type="text" formControlName="nombre" placeholder="Buscar...">
              </div>

              <div class="filter-group">
                <label>Sexo</label>
                <select formControlName="sexo">
                  <option value="">Todos</option>
                  <option value="M">Masculino</option>
                  <option value="F">Femenino</option>
                </select>
              </div>

              <div class="filter-group">
                <label>Nacionalidad</label>
                <input type="text" formControlName="nacionalidad" placeholder="Buscar...">
              </div>

              <!-- ROW 2: Nro. Libreta Range (span 2) | Fecha Nacimiento Range (span 2) -->
              <div class="filter-group span-2">
                <label>Nro. Libreta (Rango)</label>
                <div class="range-inputs vertical">
                  <input 
                    type="number" 
                    formControlName="nroLibretaDesde" 
                    placeholder="Desde (ej: 100)"
                    min="1"
                    [class.error]="searchForm.get('nroLibretaDesde')?.invalid">
                  <input 
                    type="number" 
                    formControlName="nroLibretaHasta" 
                    placeholder="Hasta (ej: 200)"
                    min="1"
                    [class.error]="searchForm.get('nroLibretaHasta')?.invalid">
                </div>
                <small *ngIf="searchForm.get('nroLibretaDesde')?.invalid" class="error-text">
                  {{ getFieldErrorMessage('nroLibretaDesde') }}
                </small>
                <small *ngIf="searchForm.get('nroLibretaHasta')?.invalid" class="error-text">
                  {{ getFieldErrorMessage('nroLibretaHasta') }}
                </small>
              </div>

              <div class="filter-group span-2">
                <label>Fecha Nacimiento (Rango)</label>
                <div class="range-inputs">
                  <input 
                    type="date" 
                    formControlName="fcNacimientoDesde"
                    [max]="TODAY"
                    [min]="MIN_BIRTH_DATE"
                    [class.error]="searchForm.get('fcNacimientoDesde')?.invalid">
                  <input 
                    type="date" 
                    formControlName="fcNacimientoHasta"
                    [max]="TODAY"
                    [min]="MIN_BIRTH_DATE"
                    [class.error]="searchForm.get('fcNacimientoHasta')?.invalid">
                </div>
                <small *ngIf="searchForm.get('fcNacimientoDesde')?.invalid" class="error-text">
                  {{ getFieldErrorMessage('fcNacimientoDesde') }}
                </small>
                <small *ngIf="searchForm.get('fcNacimientoHasta')?.invalid" class="error-text">
                  {{ getFieldErrorMessage('fcNacimientoHasta') }}
                </small>
              </div>

              <!-- ROW 3: Tipo Graduación | GUP/DAN | Cert DAN (span 2 if DAN) | NGB (or empty if DAN cert takes 2) -->
              <div class="filter-group">
                <label>Tipo Graduación</label>
                <select formControlName="gradoTipo" (change)="onGradoTipoChange()">
                  <option value="">Todos</option>
                  <option value="GUP">GUP</option>
                  <option value="DAN">DAN</option>
                </select>
              </div>

              <!-- GUP Selection (conditionally shown) -->
              <div class="filter-group" *ngIf="searchForm.get('gradoTipo')?.value === 'GUP'">
                <label>Número GUP</label>
                <select formControlName="gup">
                  <option value="">Todos</option>
                  <option *ngFor="let item of gupList" [value]="item.value">
                    {{ item.label }}
                  </option>
                </select>
              </div>

              <!-- DAN Selection (conditionally shown) -->
              <div class="filter-group" *ngIf="searchForm.get('gradoTipo')?.value === 'DAN'">
                <label>Número DAN</label>
                <select formControlName="dan">
                  <option value="">Todos</option>
                  <option *ngFor="let item of danList" [value]="item.value">
                    {{ item.label }}
                  </option>
                </select>
              </div>

              <!-- Certificado DAN (spans 2 when DAN selected) -->
              <div class="filter-group" 
                  [class.span-2]="searchForm.get('gradoTipo')?.value === 'DAN'"
                  *ngIf="searchForm.get('gradoTipo')?.value === 'DAN'">
                <label>N° Certificado DAN</label>
                <input type="text" formControlName="nuCertDan" placeholder="Ej: AR-1-1234">
              </div>

              <!-- NGB field (only shows when NOT DAN or when DAN cert doesn't take 2 cols) -->
              <div class="filter-group" *ngIf="searchForm.get('gradoTipo')?.value !== 'DAN'">
                <label>NGB</label>
                <input type="text" formControlName="ngb" placeholder="Buscar...">
              </div>

              <!-- Empty placeholder when DAN cert spans 2 -->
              <div class="filter-group" *ngIf="searchForm.get('gradoTipo')?.value === 'DAN'">
                <label>NGB</label>
                <input type="text" formControlName="ngb" placeholder="Buscar...">
              </div>

              <!-- ROW 4: Email NGB | Estado Matrícula | Año Matrícula | (empty or future field) -->
              <div class="filter-group">
                <label>Email NGB</label>
                <input type="email" formControlName="emailNgb" placeholder="Buscar...">
              </div>

              <div class="filter-group">
                <label>Estado Matrícula</label>
                <select formControlName="matriculaVigente">
                  <option value="">Todos</option>
                  <option value="SI">Vigente</option>
                  <option value="NO">Vencido/Sin Pago</option>
                </select>
              </div>

              <div class="filter-group">
                <label>Año Matrícula</label>
                <input type="number" formControlName="matriculaAnio" placeholder="2024" min="2020" max="2100">
              </div>

            </div>

            <!-- Filter Buttons (remain the same) -->
            <div class="filter-buttons">
              <button 
                type="submit" 
                class="btn-search"
                [disabled]="hasValidationErrors()">
                <i class="fas fa-search"></i> Buscar
              </button>
              <button 
                type="button" 
                class="btn-reset" 
                (click)="resetFilters()">
                <i class="fas fa-times"></i> Limpiar filtros
              </button>
            </div>
          </div>
        </form>
      </div>

      <!-- Results Container -->
      <div class="results-container">
        <!-- Loading Spinner -->
        <div *ngIf="loading" class="loading-spinner">
          <i class="fas fa-spinner fa-spin"></i> Cargando...
        </div>

        <!-- Error Message -->
        <div *ngIf="errorMessage && !loading" class="error-message">
          <i class="fas fa-exclamation-triangle"></i> {{ errorMessage }}
        </div>

        <!-- Results Header with Pagination Info -->
        <div *ngIf="!loading && filteredRecords.length > 0" class="results-header">
          <div class="results-info">
            <div>Se encontraron {{ filteredRecords.length }} registros</div>
            <div class="pagination-info">
              Mostrando {{ (currentPage - 1) * pageSize + 1 }} - {{ Math.min(currentPage * pageSize, filteredRecords.length) }} de {{ filteredRecords.length }}
            </div>
          </div>
        </div>

        <!-- Pagination Controls (Top) -->
        <div *ngIf="totalPages > 1 && !loading && filteredRecords.length > 0" class="pagination-controls">
          <button 
            class="pagination-button" 
            [disabled]="currentPage === 1"
            (click)="goToPage(1)">
            <i class="fas fa-angle-double-left"></i>
          </button>
          <button 
            class="pagination-button" 
            [disabled]="currentPage === 1"
            (click)="previousPage()">
            <i class="fas fa-angle-left"></i>
          </button>
          
          <div class="page-numbers">
            <button 
              *ngFor="let page of getPageNumbers()"
              class="pagination-button" 
              [class.active]="page === currentPage"
              (click)="goToPage(page)">
              {{ page }}
            </button>
          </div>
          
          <button 
            class="pagination-button" 
            [disabled]="currentPage === totalPages"
            (click)="nextPage()">
            <i class="fas fa-angle-right"></i>
          </button>
          <button 
            class="pagination-button" 
            [disabled]="currentPage === totalPages"
            (click)="goToPage(totalPages)">
            <i class="fas fa-angle-double-right"></i>
          </button>
        </div>

        <!-- Results Table -->
        <div *ngIf="!loading && filteredRecords.length > 0" class="table-container">
          <table class="itf-table">
            <thead>
              <tr>
                <th>Nro. Libreta</th>
                <th>Nombre</th>
                <th>Apellido</th>
                <th>Fecha Nac.</th>
                <th>Sexo</th>
                <th>Graduación</th>
                <th>N° Cert. DAN</th>
                <th>NGB</th>
                <th>Nacionalidad</th>
                <th>Email NGB</th>
                <th colspan="3" class="group-header">Matrícula</th>
                <th colspan="3" class="group-header">Auditoría</th>
                <th>Detalle</th>
              </tr>
              <tr class="sub-header">
                <th colspan="10"></th>
                <th>Estado</th>
                <th>Año</th>
                <th>Pagar</th>
                <th>Creado</th>
                <th>Actualizado</th>
                <th>Por</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let record of paginatedRecords">
                <!-- Basic Info (10 columns) -->
                <td class="center">{{ record.nroLibreta || '-' }}</td>
                <td>{{ record.nombre }}</td>
                <td>{{ record.apellido }}</td>
                <td class="center">{{ formatDate(record.fcNacimiento) }}</td>
                <td class="center">{{ record.sexo }}</td>
                <td>{{ getGraduacionDisplay(record) }}</td>
                <td>{{ record.nuCertDan || '-' }}</td>
                <td>{{ record.ngb }}</td>
                <td>{{ record.nacionalidad }}</td>
                <td class="email">{{ record.emailNgb || '-' }}</td>
                
                <!-- Matrícula Section (3 columns) -->
                <td class="center">
                  <span class="status-badge" [ngClass]="getPaymentStatusBadge(record).class">
                    {{ getPaymentStatusBadge(record).text }}
                  </span>
                </td>
                <td class="center">{{ record.matriculaAnio || '-' }}</td>
                
                <!-- Pagar column -->
                <td class="center">
                  <button 
                    (click)="onOpenPaymentModal(record, $event)"
                    class="btn-pay"
                    title="Registrar pago">
                    <i class="fas fa-dollar-sign"></i>
                  </button>
                </td>
                
                <!-- Auditoría Section (3 columns) -->
                <td class="center date-small">{{ formatDate(record.createdAt) }}</td>
                <td class="center date-small">{{ formatDate(record.updatedAt) }}</td>
                <td class="center">{{ getUsernameById(record.createdBy) }}</td>
                
                <!-- Detalle Section -->
                <td class="actions">
                  <div class="action-buttons">
                    <button 
                      *ngIf="record.nroLibreta"
                      (click)="onViewEstudianteDetail(record)"
                      class="btn-action btn-estudiante"
                      title="Ver Estudiante">
                      <i class="fas fa-user"></i>
                    </button>
                    <button 
                      (click)="onViewItfDetail(record)"
                      class="btn-action btn-itf"
                      title="Ver ITF Database">
                      <i class="fas fa-address-card"></i>
                    </button>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <!-- No Results -->
        <div *ngIf="!loading && filteredRecords.length === 0 && itfRecords.length === 0" class="no-results">
          <i class="fas fa-search"></i>
          <p>No se encontraron registros con los filtros aplicados</p>
          <p class="hint">Intente ajustar los criterios de búsqueda</p>
        </div>

        <!-- Pagination Controls (Bottom) -->
        <div *ngIf="totalPages > 1 && !loading && filteredRecords.length > 0" class="pagination-controls">
          <button 
            class="pagination-button" 
            [disabled]="currentPage === 1"
            (click)="goToPage(1)">
            <i class="fas fa-angle-double-left"></i>
          </button>
          <button 
            class="pagination-button" 
            [disabled]="currentPage === 1"
            (click)="previousPage()">
            <i class="fas fa-angle-left"></i>
          </button>
          
          <div class="page-numbers">
            <button 
              *ngFor="let page of getPageNumbers()"
              class="pagination-button" 
              [class.active]="page === currentPage"
              (click)="goToPage(page)">
              {{ page }}
            </button>
          </div>
          
          <button 
            class="pagination-button" 
            [disabled]="currentPage === totalPages"
            (click)="nextPage()">
            <i class="fas fa-angle-right"></i>
          </button>
          <button 
            class="pagination-button" 
            [disabled]="currentPage === totalPages"
            (click)="goToPage(totalPages)">
            <i class="fas fa-angle-double-right"></i>
          </button>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- ============================================================================
     MODALS
     ============================================================================ -->

<!-- Modal for ITF Database Detail -->
<div class="modal-overlay" *ngIf="showItfDetail" (click)="onCloseItfDetail()">
  <div class="modal-content modal-large" (click)="$event.stopPropagation()">
    <button class="modal-close" (click)="onCloseItfDetail()">
      <i class="fas fa-times"></i>
    </button>
    <app-itf-database-detail 
      [itfRecord]="selectedRecord!"
      [isNew]="false"
      (cancelEdit)="onCloseItfDetail()">
    </app-itf-database-detail>
  </div>
</div>

<!-- Modal for Estudiante Detail -->
<div class="modal-overlay" *ngIf="showEstudianteDetail" (click)="onCloseEstudianteDetail()">
  <div class="modal-content modal-large" (click)="$event.stopPropagation()">
    <button class="modal-close" (click)="onCloseEstudianteDetail()">
      <i class="fas fa-times"></i>
    </button>
    <app-estudiante-detail 
      [estudiante]="selectedEstudiante"
      (cancelEdit)="onCloseEstudianteDetail()">
    </app-estudiante-detail>
  </div>
</div>

<app-itf-payment-modal
  *ngIf="selectedRecordForPayment"
  [itfRecord]="selectedRecordForPayment"
  [show]="showPaymentModal"
  (close)="onClosePaymentModal()"
  (paymentRegistered)="onPaymentRegistered($event)">
</app-itf-payment-modal>